import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { createStructuredSelector } from 'reselect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { loadCommentsData } from './actions';
import Form from './form';
import {
  makeSelectComments,
  makeSelectLoading,
  makeSelectCountComment,
} from './selectors';
import ListComment from './ListComment';
import {
  makeSelectProfile,
  makeSelectIsAuthenticated,
} from '../AuthProvider/selectors';
import { FormattedDate } from '~/lib';
import { withI18next } from '~/../hocs/_withI18next';
import Config from '~/config';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import IconCountComment from '~/components/svg/comment-icon-count.svg';
import config from '~/config';
import themeVariables from '~/shared/themeVariables';

@withI18next()
class Comment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginURL: '',
      signupURL: '',
    };
  }
  componentDidMount() {
    let { lng } = this.props;
    this.setState({
      loginURL: `${
        config.ssoServerUrl
      }/login?lang=${lng}&serviceURL=${encodeURIComponent(
        window.location.href,
      )}`,
      signupURL: `${
        config.ssoServerUrl
      }/signup?lang=${lng}&serviceURL=${encodeURIComponent(
        window.location.href,
      )}`,
      setStateFirst: false,
    });
  }
  render() {
    const {
      comments = [],
      loading,
      lng,
      isAuthenticated,
      profile,
      id,
      countComment,
      t,
    } = this.props;
    const { loginURL, signupURL } = this.state;
    return (
      <div className={`row comment-component ${Config.serviceType}`}>
        <div className="information-comment">
          <div className="icon-count">
            <IconCountComment />
          </div>
          <div className="count-text">
            {t('count_comment', { countComment: countComment })}
          </div>
        </div>
        {!isAuthenticated && (
          <div
            className="container-content-no-login"
            dangerouslySetInnerHTML={{
              __html: t('login_or_signup_comment', {
                loginURL,
                signupURL,
              }),
            }}
          />
        )}
        {isAuthenticated && (
          <div className="">
            <Form data_id={id} t={t} />
          </div>
        )}
        <div className="">
          {loading ? (
            <LoadingSpinner style={{ padding: '40px 0' }} />
          ) : (
            <ListComment data={comments} t={t} />
          )}
        </div>
        <style jsx>
          {`
            .information-comment {
              display: flex;
              gap: 8px;
              margin-bottom: 24px;
            }
            .comment-component {
              padding-top: 24px;
              border-top: 1px solid #051019;
              margin-top: 16px;
            }
          `}
        </style>
        <style jsx global>
          {`
            .comment-component form button {
              float: right;
            }

            .comment-component .media-body .form-group {
              margin-bottom: 10px;
            }

            .comment-component .media-body .creator-translate {
              display: inline-block;
              float: right;
            }

            .container-comment-content {
              background: #f8f9fa;
              padding: 8px;
            }

            .comment-component.photo_ac .error-form {
              border: 1px solid #509bdc;
              -webkit-transition: border ease-in-out 0.3s;
              -moz-transition: border ease-in-out 0.3s;
              -ms-transition: border ease-in-out 0.3s;
              -o-transition: border ease-in-out 0.3s;
              transition: border ease-in-out 0.3s;
            }

            .comment-component.photo_ac .btn {
              background-color: #509bdc;
              border: 1px solid #509bdc;
            }

            .comment-component.illust_ac .error-form {
              border: 1px solid #d73a4e;
              -webkit-transition: border ease-in-out 0.3s;
              -moz-transition: border ease-in-out 0.3s;
              -ms-transition: border ease-in-out 0.3s;
              -o-transition: border ease-in-out 0.3s;
              transition: border ease-in-out 0.3s;
            }

            .comment-component.illust_ac .btn {
              background-color: #d73a4e;
              border: 1px solid #d73a4e;
            }

            .comment-component.silhouette_ac .error-form {
              border: 1px solid #41b9b8;
              -webkit-transition: border ease-in-out 0.3s;
              -moz-transition: border ease-in-out 0.3s;
              -ms-transition: border ease-in-out 0.3s;
              -o-transition: border ease-in-out 0.3s;
              transition: border ease-in-out 0.3s;
            }

            .comment-component.silhouette_ac .btn {
              background-color: #41b9b8;
              border: 1px solid #41b9b8;
            }

            .comment-component.design_ac .error-form {
              border: 1px solid #ffa823;
              -webkit-transition: border ease-in-out 0.3s;
              -moz-transition: border ease-in-out 0.3s;
              -ms-transition: border ease-in-out 0.3s;
              -o-transition: border ease-in-out 0.3s;
              transition: border ease-in-out 0.3s;
            }

            .comment-component.design_ac .btn {
              background-color: #ffa823;
              border: 1px solid #ffa823;
            }
            @media only screen and (max-width: ${themeVariables.breakpoints
                .tabletS.minWidth}px) {
              .comment-component {
                padding: 24px 16px 0 16px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  comments: makeSelectComments(),
  loading: makeSelectLoading(),
  isAuthenticated: makeSelectIsAuthenticated(),
  profile: makeSelectProfile(),
  countComment: makeSelectCountComment(),
});

const mapDispatchToProps = (dispatch) => ({
  loadCommentsData: (query) => dispatch(loadCommentsData(query)),
});

const Connector = connect(mapStateToProps, mapDispatchToProps)(Comment);

export default Connector;
